import { ReactNode } from 'react';
// 组件
import { QuestionCircleOutlined } from '@ant-design/icons';
import { ProTooltip } from '../../antd';
// 方法
import dayjs from 'dayjs';
import classNames from 'classnames';
// 常量
import { SuperFormItemProps } from '../../SuperForm';
import { TooltipProps } from 'antd/lib/tooltip';
import {
  DEFAULT_DATA_FORMAT,
  DETAULT_TIME_FORMAT,
} from '../../constants/constant';
import { AlignType } from '../../constants/interface';

export function getDefauleSearchParams(
  defauleSearchParams?: any,
  formItems?: SuperFormItemProps[],
): any {
  const params = { ...defauleSearchParams };
  formItems?.forEach(item => {
    const {
      initialValue,
      name,
      formItemType,
      timePickerProps,
      rangePickerProps,
      datePickerProps,
      options,
      zoneProps,
      zoneTimeProps,
      beforeFormItemProps,
      afterFormItemProps,
    } = item;
    if (formItemType === 'SelectGroupTable') {
      if (beforeFormItemProps) {
        const { initialValue, name } = beforeFormItemProps;
        if (typeof name === 'string') params[name] = initialValue;
      }
      if (afterFormItemProps) {
        const { initialValue, name } = afterFormItemProps;
        if (typeof name === 'string') params[name] = initialValue;
      }
    }
    if (initialValue !== undefined && typeof name === 'string') {
      switch (formItemType) {
        case 'TimePicker':
          params[name] = dayjs.isDayjs(initialValue)
            ? initialValue.format(
                (timePickerProps?.format as string) || DETAULT_TIME_FORMAT,
              )
            : initialValue;
          break;
        case 'DatePicker':
          params[name] = dayjs.isDayjs(initialValue)
            ? initialValue.format(
                (datePickerProps?.format as string) || DEFAULT_DATA_FORMAT,
              )
            : initialValue;
          break;
        case 'RangePicker':
          if (Array.isArray(initialValue)) {
            params[name] = initialValue.map(v => {
              return dayjs.isDayjs(v)
                ? v.format(
                    (rangePickerProps?.format as string) || DEFAULT_DATA_FORMAT,
                  )
                : v;
            });
          }
          break;
        default:
          params[name] = initialValue;
      }
    }
    if (
      Array.isArray(initialValue) &&
      Array.isArray(name) &&
      initialValue.length
    ) {
      if (formItemType === 'SelectCustom') {
        const selectValue = initialValue[0];
        const momentValue = initialValue[1];
        const findOption = options?.find(v => v.value === selectValue);
        params[name[0]] = selectValue;
        if (findOption) {
          switch (findOption.afterFormItemType) {
            case 'DatePicker':
              params[name[1]] = dayjs.isDayjs(momentValue) ? momentValue.format((findOption.datePickerProps?.format as string) || DEFAULT_DATA_FORMAT) : momentValue;
              break;
            case 'TimePicker':
              params[name[1]] = dayjs.isDayjs(momentValue) ? momentValue.format((findOption.timePickerProps?.format as string) || DETAULT_TIME_FORMAT) : momentValue;
              break;
            case 'RangePicker':
              params[name[1]] = momentValue?.map?.((v: any) => {
                return dayjs.isDayjs(v) ? v.format((findOption.rangePickerProps?.format as string) || DEFAULT_DATA_FORMAT) : v;
              });
              break;
            default:
              params[name[1]] = momentValue;
          }
        }
      } else if (formItemType === 'ZoneTime') {
        let timeValue: any = '';
        let timeName: any = '';
        let timeTypeValue: any = '';
        if (zoneProps) {
          const zoneValue = initialValue[0];
          timeTypeValue = initialValue[1];
          timeValue = initialValue[2];
          timeName = name[2];
          if (zoneValue) params[name[0]] = zoneValue;
          if (timeTypeValue) params[name[1]] = timeTypeValue;
        } else {
          timeTypeValue = initialValue[0];
          timeValue = initialValue[1];
          timeName = name[1];
          if (timeTypeValue) params[name[0]] = timeTypeValue;
        }
        const findOption = zoneTimeProps?.options?.find(v => v.value === timeTypeValue);
        if (findOption && timeName && timeValue) {
          switch (findOption.timeType) {
            case 'DatePicker':
              params[timeName] = dayjs.isDayjs(timeValue) ? timeValue.format((findOption.datePickerProps?.format as string) || DEFAULT_DATA_FORMAT) : timeValue;
              break;
            case 'RangePicker':
              params[timeName] = timeValue?.map?.((v: any) => {
                return dayjs.isDayjs(v) ? v.format((findOption.rangePickerProps?.format as string) || DEFAULT_DATA_FORMAT) : v;
              });
              break;
          }
        }
      } else if (formItemType === 'TimeSlot') {
        initialValue.forEach((momentValue, index) => {
          params[name[index]] = dayjs.isDayjs(momentValue) ? momentValue.format((datePickerProps?.format as string) || DEFAULT_DATA_FORMAT) : momentValue;
        });
      } else {
        name.forEach((v, k) => {
          params[v] = initialValue[k];
        });
      }
    }
  });
  return params;
}

export function getRowKey(
  record: any,
  rowKey?: string | ((record: any) => string),
): string {
  if (!rowKey) return record?.key;
  if (typeof rowKey === 'string') return record?.[rowKey];
  return rowKey(record);
}
/**
 * 
 * @param title 标题
 * @param tooltip 提示
 * @param align 对齐方式
 * @param required 是否必填
 * @returns 
 */
export function setColumnTitle(
  title?: any,
  tooltip?: string | TooltipProps,
  align: AlignType = 'left',
  required: boolean = false,
): ReactNode {
  // if (!tooltip) return title;
  const classes = classNames({
    'edit-table-column-required': required,
    'flex-center-start': align === 'left',
    'flex-center-center': align === 'center',
    'flex-center-end': align === 'right',
  });
  if (!tooltip) {
    return (<div className={classes}>{title}</div>);
  }
  if (typeof tooltip === 'string') {
    return (
      <div className={classes}>
        {title}
        <ProTooltip title={tooltip} placement="top">
          <QuestionCircleOutlined className='yb-help-tooltip p-l-s' />
        </ProTooltip>
      </div>
    );
  }
  return (<div className={classes}>
    {title}
    <ProTooltip {...tooltip}>
      <QuestionCircleOutlined className='yb-help-tooltip p-l-s' />
    </ProTooltip>
  </div>)
}
